export default "__VITE_ASSET__BHarbpJV__"